export const NO_UPLOADS_COPY = 'No recent uploads';
